export type PurchaseTaxonomies = {
  checkoutPageViewed: {
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    cartItemsAmount?: number
    productAmount?: number
    subTotalPrice?: number
    isTipAccepted?: number
    deliveryAmountToPay?: number
    amountToPay?: number
    isScheduledOrder?: boolean
    timeLabeL?: string
    minDeliveryTime?: string
    maxDeliveryTime?: string
    currentPreparationDuration?: string
    currentDeliveryDuration?: string
    availablePaymentTypes?: string
    userId?: string
    countryCode?: string
  }
  productAdded: {
    categoryId?: string
    categoryName?: string
    productName?: string
    productId?: string
    productDescription?: string
    productAmount?: number
    fullPrice?: number
    productDiscount?: number
    productTotalPrice?: number
    amountRequiredModifiers?: number
    amountOptionalModifiers?: number
    selectedOptionalModifiers?: number
    actionLocation?: string
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    menuId?: string
    userId?: string
    countryCode?: string
  }
}

export const PURCHASE_EVENTS = Object.freeze({
  checkoutPageViewed: 'checkout-page-viewed',
  productAdded: 'product-added'
})
